<div class="grid-container" style="position: relative;"
    [ngStyle]="dynamic_headers?.length <= 4 ? {'width': '80%', 'margin': '0 auto'} : {}">
    <ejs-grid #grid id="Orders" *ngIf="dynamic_headers.length > 0 && data" [rowHeight]="24" [allowTextWrap]="false"
        class="full-width-table overRide-gridPosition" [dataSource]="data" [allowPaging]="pagination"
        [allowFiltering]="true" [allowSorting]="true" [filterSettings]="filterOption" [allowSelection]="false"
        [enableHover]="false" [enableHeaderFocus]="true" [allowExcelExport]="true" [allowPdfExport]="true"
        [showColumnChooser]="true" [allowSelection]="true" [frozenColumns]="freezeColumns"
        [height]="isOptionRequired ? returnsAnalyzerOptions?'200':'400' : '600'" [toolbar]="toolbar"
        (toolbarClick)="toolbarClick($event)" (actionBegin)="actionBegin($event)" [loadingIndicator]="loadingIndicator"
        (rowSelected)="onRowSelected($event)" [pageSettings]="pageSettings" [editSettings]="editSettings"
        allowTextWrap='true' (rowDataBound)='rowDataBound($event)' [textWrapSettings]='wrapSettings'
        (dataStateChange)='dataStateChange($event)' [enableStickyHeader]="true" height="400"
        [enablePersistence]="false">
        <e-columns>
            <ng-container *ngFor="let header of dynamic_headers">
                <e-column [field]="header.field" [headerText]="header.headerText"
                    [allowFiltering]="['openPOQty', 'canOrderQty'].includes(header.field) ? true : header.allowFiltering"
                    [disableHtmlEncode]="false" [filter]="header.filter || { type: 'Menu' }"
                    [width]="header.pins ? 200 : header.width" [textAlign]="header.textAlign"
                    [isPrimaryKey]="header.field ==='materialCode' || header.field ==='parent'">
                    <ng-template #template let-data>
                        <div *ngIf="header.pins ? cachedPinCounts !== undefined : true">
                            <app-dynamic-column-molecule [columnType]="columnTypes[header.field]" [data]="data"
                                [reportName]="reportName" [updateGrid]="updateGridHandler.bind(this)"
                                [isOptionRequired]="isOptionRequired" [readOnlyMode]="readOnlyMode" [header]="header"
                                [dynamicNormForm]="dynamicNormForm" (onPopup)="handlePOPUP($event)"
                                (dataEmitForSalesEvent)="handleSalesEventData($event)"
                                [cachedPinCounts]="cachedPinCounts" (refreshPins)="refreshPinCount()"
                                (edit)="editData($event)" (delete)="deleteData($event)"
                                [workOrderData]="workOrderData"></app-dynamic-column-molecule>
                        </div>
                    </ng-template>
                </e-column>
            </ng-container>
        </e-columns>
    </ejs-grid>
</div>